<div class="whats-new-content">
  <div mat-dialog-content>
    <div class="slider-header">
      <h1>What's New</h1>
      <div class="close-button" (click)="closeDialog()">
        <i data-feather="x" class="feather-icon"></i>
      </div>
    </div>
    <div class="slider-content">
      <div class="slide">
        <ng-container *ngIf="currentSlide.video_url; else imageSlide">
          <div class="video-card">
            <iframe *ngIf="currentSlide.isYouTubeUrl" [src]="currentSlide.video_url" frameBorder="0"
              allowfullscreen></iframe>
            <video *ngIf="!currentSlide.isYouTubeUrl" controls>
              <source [src]="currentSlide.video_url" type="video/mp4">
              <source [src]="currentSlide.video_url" type="video/webm">
              <source [src]="currentSlide.video_url" type="video/ogg">
              <source [src]="currentSlide.video_url" type="video/m4a">
              Your browser does not support the video tag.
            </video>
          </div>
        </ng-container>
        <ng-template #imageSlide>
          <div class="video-card">
            <img [src]="currentSlide.image_url" alt="Slide Image">
          </div>
        </ng-template>
        <div>
          <div class="dots-navigation flex-centered-container-hr" *ngIf="slides?.length > 1">
            <span *ngFor="let slide of slides; let i = index" class="dot cursor-pointer display-inline-block"
              [ngClass]="slide.className" (click)="goToSlide(i)">
            </span>
          </div>
          <h2>{{currentSlide.title}}</h2>
          <p class="description" [innerHTML]="currentSlide.description"></p>
        </div>
      </div>
      <hr>
      <div class="slider-navigation" *ngIf="slides?.length > 1">
        <button mat-button class="back fit-content" (click)="previousSlide()"
          [disabled]="currentSlideIndex === 0">Back</button>
        <button mat-button class="next fit-content" (click)="nextSlide()"
          [disabled]="currentSlideIndex === slides.length - 1">Next</button>
      </div>
      <div class="slider-navigation" *ngIf="slides?.length === 1">
        <button mat-button class="next fit-content" (click)="closeDialog()">Close</button>
      </div>
    </div>
  </div>
</div>